export default __webpack_public_path__ + "static/index-header-img-84db95f1c55271cc43a4787da36f81c1.webp";